import { createContext, useCallback, useContext, useState, ReactNode } from "react";
import { ONBOARDING_STORAGE_KEY } from "@/lib/onboardingSteps";

interface OnboardingContextType {
  isRunning: boolean;
  startTour: () => void;
  restartTour: () => void;
  stopTour: () => void;
  hasCompleted: boolean;
}

const OnboardingContext = createContext<OnboardingContextType>({
  isRunning: false,
  startTour: () => {},
  restartTour: () => {},
  stopTour: () => {},
  hasCompleted: false,
});

export function OnboardingProvider({ children }: { children: ReactNode }) {
  const [isRunning, setIsRunning] = useState(false);

  const startTour = useCallback(() => setIsRunning(true), []);
  const stopTour = useCallback(() => setIsRunning(false), []);
  const restartTour = useCallback(() => {
    localStorage.removeItem(ONBOARDING_STORAGE_KEY);
    setIsRunning(true);
  }, []);

  const hasCompleted = !!localStorage.getItem(ONBOARDING_STORAGE_KEY);

  return (
    <OnboardingContext.Provider value={{ isRunning, startTour, restartTour, stopTour, hasCompleted }}>
      {children}
    </OnboardingContext.Provider>
  );
}

export const useOnboarding = () => useContext(OnboardingContext);
